import startCase from 'lodash/startCase'
import { JLPActionTypes } from '../../../../../actions/dashboards/JLP'
import { Metrics } from '../../../../../constants/Dashboards'
import { getColor } from '../../../../../containers/Dashboard/reduxIntegration/getReducer/colors'
import buildAsyncStatReducer from '../../asyncStatReducer'

type ButtonsPayload = {
  type: string;
  button: string;
  count: number;
}[]

type ButtonsCount = {
    [buttonLabel: string]: number[];
}

type ButtonsState = {
  values: ButtonsCount;
  labels: string[];
  total: number;
  perc: null;
  colors: string[];
}

/**
 * Ark Dwell Time per Sku reducer
 */
 const JLPButtons = buildAsyncStatReducer<ButtonsPayload, ButtonsState>({
  key: Metrics.JLP_BUTTONS,
  types: {
    request: JLPActionTypes.DASHBOARD_JLP_BUTTONS.request,
    success: JLPActionTypes.DASHBOARD_JLP_BUTTONS.success,
    failure: JLPActionTypes.DASHBOARD_JLP_BUTTONS.failure,
  },
  transform: (state, { payload }): ButtonsState => {
    let total = 0;
    const colors: string[] = [];
  
    const buttons: ButtonsCount = payload
      .sort(({ count: countA }, { count: countB }) => countA - countB)
      .reduce((out, row): ButtonsCount => {
        const { type = '', button = '', count } = row;
        const buttonLabel = startCase(`${type} ${button ?? ''}`);
        colors.push(getColor(type));
  
        total += count;
        return { ...out, [buttonLabel]: [count] };
      }, {})
    
    return {
      values: buttons,
      labels: [''],
      total,
      perc: null,
      colors,
    }
  },
})

export default JLPButtons
